import { getAllShelfNames } from '../services/SKUListAPI';
import { invalidateCachedListByLabel, useCachedListValidation } from './useCachedListValidation';

const normalizeShelf = (shelf: string): string => String(shelf || '').toUpperCase().trim();

interface UseShelfValidationResult {
  allShelfNames: string[];
  loading: boolean;
  error: string | null;
  validateShelf: (shelf: string) => boolean;
  normalizeShelf: (shelf: string) => string;
  refreshShelves: () => Promise<void>;
}

export function invalidateShelfCache(): void {
  invalidateCachedListByLabel('shelves');
}

export function useShelfValidation(): UseShelfValidationResult {
  const { items: allShelfNames, loading, error, validate, refresh, invalidateCache } =
    useCachedListValidation({
      fetchItems: getAllShelfNames,
      normalize: normalizeShelf,
      label: 'shelves',
    });

  const refreshShelves = async (): Promise<void> => {
    invalidateCache();
    await refresh();
  };

  return {
    allShelfNames,
    loading,
    error,
    validateShelf: validate,
    normalizeShelf,
    refreshShelves,
  };
}
